import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Media,
  Modal,
  UncontrolledDropdown
} from 'reactstrap';

// constants
import appIcons from '../../constants/appIcons';
import LocalStrings from '../../assets/languages';
import { ALLOWED_APP_THEMES } from '../../constants/section-constants/type-constants';

// actions
import { updateAppLanguage, updateAppTheme } from '../../actions';

// components
import { renderSelectWOnChange } from '../Common/base-components';

const INITIAL_LANG_DATA = {
  allowed: true,
  allLangs: [],
  setLang: {}
};

const AppSettings = props => {
  const {
    // state
    session,
    eventDetails,
    eventSettings,
    eventLanguages,
    showThemeDD,
    userChosenTheme,

    // components
    isOpen,
    closeModal = () => {}
  } = props;

  const [languageSettings, setLanguageSettings] = useState(INITIAL_LANG_DATA);

  useEffect(() => {
    const setAppLanguage = _.find(eventLanguages, lang =>
      _.isEqual(lang?.languagekey, session?.language)
    );

    setLanguageSettings({
      allowed: eventLanguages?.length > 1,
      setLang: setAppLanguage,
      allLangs: eventLanguages
    });
  }, []);

  const handleThemeToggle = theme => {
    props.updateAppTheme(
      eventDetails,
      eventSettings,
      theme,
      session?.userChoseTheme,
      false
    );
  };

  const _renderThemeDD = () => {
    return showThemeDD ? (
      <div className="row border-bottom pb-2 mx-0">
        <div className="col-6 col-sm-6 col-lg-8 px-0 d-flex flex-column justify-content-start align-content-start">
          <span className="custom-text8-medium-primary">
            {LocalStrings.dynamic.kDarkModeSettings}
          </span>

          <span className="custom-text9-normal-secondary">
            {LocalStrings.dynamic.kDarkModeSettingsDesc}
          </span>
        </div>
        <div className="col-6 col-sm-6 col-lg-4 px-0 d-flex justify-content-end align-items-center">
          {renderSelectWOnChange({
            meta: {
              touched: true,
              error: ''
            },
            textStyle: {
              fontSize: '19px',
              fontWeight: '400',
              color: _.isEqual(session?.theme, ALLOWED_APP_THEMES.dark)
                ? 'var(--theme-dark-font-primary)'
                : 'var(--primary-text-color)'
            },
            opts: ALLOWED_APP_THEMES.options,
            value: userChosenTheme,
            callback: theme => handleThemeToggle(theme)
          })}
        </div>
      </div>
    ) : (
      ''
    );
  };

  const _renderLanguageDD = () => {
    const handleLanguageOptionSelect = lang => {
      props.updateAppLanguage(lang?.languagekey);
      setTimeout(() => {
        window.location.reload();
      }, 500);
    };

    return (
      <>
        <UncontrolledDropdown>
          <DropdownToggle className="pr-0 anti-btn-secondary">
            <Media className="align-items-center">
              <span className="custom-text1-normal-theme">
                {languageSettings.setLang?.languagetext}
              </span>
            </Media>
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-arrow" right>
            {_.map(languageSettings.allLangs, (language, langKey) => {
              const selected = _.isEqual(
                LocalStrings.getLanguage(),
                language?.languagekey
              );
              const menuClass = `menu-link mb-1 ${
                selected ? 'selected-menu' : 'unselected-menu'
              }`;

              return (
                <DropdownItem
                  key={`${language?.id}${langKey}`}
                  className={menuClass}
                  onClick={() => handleLanguageOptionSelect(language)}
                >
                  <div className="menu-name">{language?.languagetext}</div>
                </DropdownItem>
              );
            })}
          </DropdownMenu>
        </UncontrolledDropdown>
      </>
    );
  };

  return (
    <Modal className="app-settings-modal" isOpen={isOpen} size="md" centered>
      <div className="modal-header custom-text2-medium-primary d-flex justify-content-between align-items-center">
        <span className="">{LocalStrings.dynamic.kSettings}</span>
        <span className="font-icomoon cursor-pointer" onClick={closeModal}>
          {appIcons.crossIcon}
        </span>
      </div>

      <div className="modal-body">
        {/* ----- Theme toggle ----- */}
        {_renderThemeDD()}

        {/* ----- Language DD ----- */}
        <div className={`row${showThemeDD ? ' pt-2' : ''} mx-0`}>
          <div className="col-6 col-sm-6 col-lg-8 px-0 d-flex flex-column justify-content-start align-items-start">
            <span className="custom-text8-medium-primary">
              {LocalStrings.dynamic.kChooseLanguage}
            </span>
            <span className="custom-text9-normal-secondary">
              {LocalStrings.dynamic.kChooseLanguageDesc}
            </span>
          </div>

          <div className="col-6 col-sm-6 col-lg-4 px-0 d-flex justify-content-end align-items-center">
            {_renderLanguageDD()}
          </div>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = state => {
  const eventSettings = state.eventSettings;

  const overviewSettings = eventSettings?.overview_settings;
  const showThemeDD =
    !_.isEmpty(overviewSettings) &&
    _.isEqual(overviewSettings?.appearance, ALLOWED_APP_THEMES.auto);

  return {
    session: state.session,
    eventDetails: state.eventDetails,
    eventSettings,
    eventLanguages: state.eventLanguages,
    userChosenTheme: state.userChosenTheme,
    showThemeDD
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ updateAppLanguage, updateAppTheme }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AppSettings);
